import React from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS } from "../i18n";

/**
 * Компактный переключатель языка (шапка). Флажок + язык в дропдауне.
 * Выбор автоматически сохраняется в localStorage (ключ tabel.lang).
 */
export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = SUPPORTED_LANGS.find(l => l.code === i18n.language)
                || SUPPORTED_LANGS.find(l => i18n.language?.startsWith(l.code))
                || SUPPORTED_LANGS[0];

  const onPick = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem("tabel.lang", code); } catch { /* ignore */ }
  };

  return (
    <div className="dropdown" data-testid="lang-switcher">
      <button className="btn btn-sm btn-light dropdown-toggle"
              type="button" data-bs-toggle="dropdown" aria-expanded="false"
              title={t("common.language")}
              data-testid="lang-switcher-btn">
        <span style={{ fontSize: 16, marginRight: 4 }}>{current.flag}</span>
        <span className="d-none d-sm-inline">{current.code.toUpperCase()}</span>
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        {SUPPORTED_LANGS.map(l => (
          <li key={l.code}>
            <button className={`dropdown-item ${l.code === current.code ? "active" : ""}`}
                    onClick={() => onPick(l.code)}
                    data-testid={`lang-${l.code}`}>
              <span style={{ fontSize: 16, marginRight: 8 }}>{l.flag}</span>
              {l.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
